"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const _1 = require(".");
/**
 * @param
 * - string type: 날짜형식 (예: "2023-08-04 04:41:52.196008")
 * - number type: django's timestamp (16자리 숫자, 뒤 3자리 자른 후 사용)
 * - number type 예시: 1691091712200545 -> 1691091712200
 * @returns example returns
 * - 08:06 (같은 날일 때)
 * - 10/14 15:47 (같은 연도일 때)
 * - 90/12/21 12:30 (다른 연도일 때)
 */
function default_1(time) {
    let timeline;
    if (typeof time === 'number') {
        timeline = (0, moment_1.default)(Math.floor(time / 1000)).format(_1.zeroSecTimeFormat);
    }
    else {
        timeline = time;
    }
    const localizedTimeline = (0, _1.changeKSTToLocalTime)(timeline);
    const localizedTimelineMoment = (0, moment_1.default)(localizedTimeline);
    const today = (0, moment_1.default)();
    const isSameDay = localizedTimelineMoment.isSame(today, 'day');
    const isSameYear = localizedTimelineMoment.isSame(today, 'year');
    if (isSameDay) {
        return localizedTimelineMoment.format('HH:mm');
    }
    else if (isSameYear) {
        return localizedTimelineMoment.format('MM/DD HH:mm');
    }
    else {
        return localizedTimelineMoment.format('YY/MM/DD HH:mm');
    }
}
exports.default = default_1;
